import React, { useEffect, useRef } from "react";
import {
  CButton,
  CCol,
  CModal,
  CFormGroup,
  CInputCheckbox,
  CLabel,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import ApoDocHdwtRegPop from "./apoDocHdwtRegPop";
import { useSelector } from "react-redux";

const ApoDocFormPop = (props) => {
  const state = useSelector((state) => state);
  const afcrNo = Number(props.afcrNo);
  const listRef = useRef();
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
  });
  const imgName = {
    10001: ["INCAR_APO_DOC_10001"],
    10002: ["INCAR_APO_DOC_10002"],
    10003: ["INCAR_APO_DOC_10003"],
    10004: ["INCAR_APO_DOC_10004"],
    10005: ["INCAR_APO_DOC_10005"],
    10006: ["INCAR_APO_DOC_10006"],
    10008: ["INCAR_APO_DOC_10008"],
    10009: ["INCAR_APO_DOC_10009"],
    10010: ["INCAR_APO_DOC_10010"],
    10011: ["INCAR_APO_DOC_10011"],
    10012: ["INCAR_APO_DOC_10012"],
    10013: ["INCAR_APO_DOC_10013"],
    10021: ["INCAR_APO_DOC_10021"],
    10023: ["INCAR_APO_DOC_10023"],
    10024: ["INCAR_APO_DOC_10024"],
    10025: ["INCAR_APO_DOC_10025"],
    10026: ["INCAR_APO_DOC_10026"],
    10028: ["INCAR_APO_DOC_10028"],
    10031: ["INCAR_APO_DOC_10031"],
    20006: ["INCAR_APO_DOC_20006"],
    99998: ["INCAR_QLFC_DOC_01"],
    99999: ["INCAR_QLFC_DOC_02"],
    10029: ["INCAR_APO_DOC_10029"],
    10022: ["INCAR_APO_DOC_10022"],
    20021: ["INCAR_APO_DOC_20021"],
  };

  useEffect(() => {
    // if(afcrNo === 10005) {
    //   const img2 = document.getElementById('img2');
  
    //   img2.onload = function() {
    //      listRef.current.scrollIntoView({block:'center'});
    //   }
    // }
  }, []);

  return (
    <>
      {/* {afcrNo === 10005? ( */}
        {/* <CModal
          className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
          show={true}
          size="lg"
          closeOnBackdrop={false}
          onClosed={() => {
            props.onClose();
          }}
        >
          <CModalBody className="apoModalBody">
            <CFormGroup row>
              <img
                id="img1"
                src={`/images/apoDocForm/${imgName[afcrNo][0]}.png`}
                alt={imgName[afcrNo][0]}
                width="100%"
              />
            </CFormGroup>
            <CFormGroup row className="signBtn">
              <CCol xs="6" className="text-left">
                <CFormGroup variant="checkbox" className="checkbox">
                  <CInputCheckbox
                    id={`${afcrNo}chk`}
                    name={`${afcrNo}chk`}
                    checked={
                      afcrNo === 10005 && state.apoDocForm.apoDocHdwtInfo[2].data
                      ? true 
                      : false
                    }
                    readOnly
                  />
                  <CLabel variant="checkbox" className="form-check-label">
                    <b>모든 내용을 숙지하고 동의</b>
                  </CLabel>
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <button ref={listRef} className="btn-footer incar" type="button" 
                  onClick={() =>
                    setHdwtRegPop({
                      isOpen: true,
                    })
                  }
                  disabled={
                    state.insert.reqTaskInfo.stCd === "10" ||
                    state.insert.reqTaskInfo.stCd === "99"
                      ? false
                      : true
                  }
                >
                  자필 작성
                </button>
              </CCol>
            </CFormGroup>
            <CFormGroup row>
              <img
                id="img2"
                src={`/images/apoDocForm/${imgName[afcrNo][1]}.png`}
                alt={imgName[afcrNo][1]}
                width="100%"
              />
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <div className="layout-footer">
              <button className="btn-footer" type="button" 
              onClick={() => {
                props.onClose(afcrNo);
              }}>
                확인
              </button>
            </div> */}
            {/* <CButton
              color="primary"
              onClick={() => {
                props.onClose(afcrNo);
              }}
            >
              확인
            </CButton> */}
          {/* </CModalFooter>
        </CModal> */}
       {/* ) : ( */}
        <CModal
          className={hdwtRegPop.isOpen ? "hideContent" : "showContent"}
          show={true}
          size="lg"
          closeOnBackdrop={false}
          onClosed={() => {
            props.onClose();
          }}
        >
          <CModalBody className="apoModalBody">
            <CFormGroup row>
              <img
                src={
                  imgName[afcrNo] !== undefined
                    ? `/images/apoDocForm/${imgName[afcrNo][0]}.png`
                    : null
                }
                alt={imgName[afcrNo] !== undefined ? imgName[afcrNo][0] : null}
                width="100%"
              />
            </CFormGroup>
          </CModalBody>
          <CModalFooter>
            <div className="layout-footer">
              <button className="btn-footer" type="button" 
              onClick={() => {
                props.onClose(afcrNo);
              }}>
                확인
              </button>
            </div>
            {/* <CButton
              color="primary"
              onClick={() => {
                props.onClose(afcrNo);
              }}
            >
              확인
            </CButton> */}
          </CModalFooter>
        </CModal>
     {/* )} */}
      {hdwtRegPop.isOpen && (
        <ApoDocHdwtRegPop
          modal={true}
          etcYn={afcrNo === 10009 ? 1 : 2}
          display={hdwtRegPop.isOpen ? "display" : ""}
          onClose={() => setHdwtRegPop({ isOpen: false })}
        ></ApoDocHdwtRegPop>
      )}
    </>
  );
};

export default ApoDocFormPop;
